<template>
  <router-view v-slot="{ Component, route }">
    <transition name="page" mode="out-in">
      <DefaultLayout v-if="currentLayout === 'default'">
        <component :is="Component" :key="route.fullPath" />
      </DefaultLayout>
      <WeeklyLayout v-else-if="currentLayout === 'weekly'">
        <component :is="Component" :key="route.fullPath" />
      </WeeklyLayout>
      <BlankLayout v-else-if="currentLayout === 'blank'">
        <component :is="Component" :key="route.fullPath" />
      </BlankLayout>
      <component :is="Component" :key="route.fullPath" v-else />
    </transition>
  </router-view>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '~/layouts/default.vue'
import WeeklyLayout from '~/layouts/weekly.vue'
import BlankLayout from '~/layouts/blank.vue'

export default {
  name: 'Child',

  components: {
    DefaultLayout,
    WeeklyLayout,
    BlankLayout
  },
  
  setup() {
    const route = useRoute()
    
    const currentLayout = computed(() => {
      // Get layout from route meta or default to none
      const layout = route.meta?.layout || null
      return layout
    })
    
    return {
      currentLayout
    }
  }
}
</script>
